import { Validator } from '@vista-digital/validator';
export const defaultOccAssets = {
    advanceBookingPeriodNotificationIconName: 'clock-solid',
    carouselNextButtonIconName: 'chevron-right',
    carouselPreviousButtonIconName: 'chevron-left',
    clearIconName: 'cross-circle',
    componentErrorIconName: 'generic-error-message',
    expandContentIndicatorIconName: 'chevron-down',
    filmWatchlistButtonIconName: 'bookmark',
    loadingIconName: 'spinner',
    modalCloseButtonIconName: 'cross',
    notificationCloseButtonIconName: 'cross',
    notificationErrorIconName: 'warning-circle',
    notificationInfoIconName: 'speech-circle',
    notificationSuccessIconName: 'check-circle',
    notificationWarningIconName: 'warning-circle',
    passwordInputHiddenIconName: 'eye',
    passwordInputVisibleIconName: 'eye-with-diagonal-line',
    passwordRuleCheckerInitialIconName: 'bullet-point',
    passwordRuleCheckerInvalidIconName: 'cross',
    passwordRuleCheckerSuccessIconName: 'check',
    orderDiscountIconName: 'star',
    zoomControllerZoomInButtonIconName: 'plus',
    zoomControllerZoomOutButtonIconName: 'minus',
    zoomControllerResetZoomButtonIconName: 'arrow-counterclockwise-bold',
    zoomControllerPanUpButtonIconName: 'chevron-up',
    zoomControllerPanDownButtonIconName: 'chevron-down',
    zoomControllerPanLeftButtonIconName: 'chevron-left',
    zoomControllerPanRightButtonIconName: 'chevron-right'
};
export const occAssetsValidator = Validator.object({
    advanceBookingPeriodNotificationIconName: Validator.optional(Validator.nonEmptyString),
    carouselNextButtonIconName: Validator.nonEmptyString,
    carouselPreviousButtonIconName: Validator.nonEmptyString,
    clearIconName: Validator.nonEmptyString,
    componentErrorIconName: Validator.nonEmptyString,
    expandContentIndicatorIconName: Validator.nonEmptyString,
    filmWatchlistButtonIconName: Validator.nonEmptyString,
    loadingIconName: Validator.nonEmptyString,
    modalCloseButtonIconName: Validator.nonEmptyString,
    notificationCloseButtonIconName: Validator.nonEmptyString,
    notificationErrorIconName: Validator.nonEmptyString,
    notificationInfoIconName: Validator.nonEmptyString,
    notificationSuccessIconName: Validator.nonEmptyString,
    notificationWarningIconName: Validator.nonEmptyString,
    passwordInputHiddenIconName: Validator.nonEmptyString,
    passwordInputVisibleIconName: Validator.nonEmptyString,
    passwordRuleCheckerInitialIconName: Validator.nonEmptyString,
    passwordRuleCheckerInvalidIconName: Validator.nonEmptyString,
    passwordRuleCheckerSuccessIconName: Validator.nonEmptyString,
    orderDiscountIconName: Validator.nonEmptyString,
    zoomControllerZoomInButtonIconName: Validator.nonEmptyString,
    zoomControllerZoomOutButtonIconName: Validator.nonEmptyString,
    zoomControllerResetZoomButtonIconName: Validator.nonEmptyString,
    zoomControllerPanUpButtonIconName: Validator.nonEmptyString,
    zoomControllerPanDownButtonIconName: Validator.nonEmptyString,
    zoomControllerPanLeftButtonIconName: Validator.nonEmptyString,
    zoomControllerPanRightButtonIconName: Validator.nonEmptyString
});
//# sourceMappingURL=assets.js.map